// import { take, call, put, select } from 'redux-saga/effects';

import { takeLatest, all, put } from "redux-saga/effects";
import {
  GET_PRODUCT_CONFIGURATION,
  GET_PRODUCT_TYPES,
} from "containers/TreatmentFlow/constants";
import { authorizedRequest } from "utils/request";
import {
  getProductConfigurationError,
  getProductConfigurationSuccess,
  getProductTypesError,
  getProductTypesSuccess,
} from "containers/TreatmentFlow/actions";

function* getEndProductTypesSaga() {
  try {
    const response = yield authorizedRequest("/ProductTypes");
    yield put(getProductTypesSuccess(response));
  } catch (error) {
    yield put(getProductTypesError(error));
  }
}

function* getProductConfigurationSaga({ upperId, lowerId }) {
  try {
    const response = yield authorizedRequest(
      `/ProductTypes/productTypeConfiguration?upperProductTypeId=${upperId}&lowerProductTypeId=${lowerId}`,
    );
    yield put(getProductConfigurationSuccess(response));
  } catch (error) {
    yield put(getProductConfigurationError(error));
  }
}

// Individual exports for testing
export default function* treatmentFlowSaga() {
  yield all([
    takeLatest(GET_PRODUCT_TYPES, getEndProductTypesSaga),
    takeLatest(GET_PRODUCT_CONFIGURATION, getProductConfigurationSaga),
  ]);
}
